import React from "react";
import ReactDOM from "react-dom";
import "../../componentes/styles/Modal.css";

function Modal({ isOpen, handleKeyUp, onClose, children, title, className = "" }) {
  if (!isOpen) {
    return null;
  }

  const _handleKeyUp =
    handleKeyUp ||
    (e => {
      if (e.key === "Escape") onClose();
    });

  return ReactDOM.createPortal(
    <div
      className="Modal"
      onKeyUp={_handleKeyUp}
      onMouseDown={onClose}
      tabIndex="-1"
    >
      <div className={`contenedor ${className}`} onMouseDown={e => e.stopPropagation()} >
        <div className="header">
          <label>{title}</label>
        </div>
        <div className="body">
          {children}
        </div>
      </div>
    </div>,
    document.getElementById("modal")
  );
}

export default Modal;
